import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useOps } from '../../../hooks/useOps';
import { credenciaisService } from './credenciais-service';

export const credenciaisQueryKeys = {
  all: ['api-credenciais'] as const,
  list: (ops: string) => [...credenciaisQueryKeys.all, ops] as const,
};

export const mensagemErro = (error: any): string =>
  error?.response?.data?.message || error?.message || 'Erro inesperado.';

export function useCredenciais() {
  const { currentOps } = useOps();

  return useQuery({
    queryKey: credenciaisQueryKeys.list(currentOps || ''),
    queryFn: () => credenciaisService.listar(String(currentOps)),
    enabled: !!currentOps,
  });
}

// criar / rotacionar / revogar: todas invalidam a lista da ops atual
export function useCredenciaisMutations() {
  const { currentOps } = useOps();
  const queryClient = useQueryClient();
  const ops = String(currentOps);
  const invalidar = () =>
    queryClient.invalidateQueries({ queryKey: credenciaisQueryKeys.list(ops) });

  return {
    criar: useMutation({
      mutationFn: (nome: string) => credenciaisService.criar(ops, nome),
      onSuccess: invalidar,
    }),
    rotacionar: useMutation({
      mutationFn: (clientId: string) => credenciaisService.rotacionar(ops, clientId),
      onSuccess: invalidar,
    }),
    revogar: useMutation({
      mutationFn: (clientId: string) => credenciaisService.revogar(ops, clientId),
      onSuccess: invalidar,
    }),
  };
}
